"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIOS = isIOS;
exports.isAndroid = isAndroid;
exports.isWechat = isWechat;
exports.isApp = isApp;
exports.isPC = isPC;
exports.isMacOS = isMacOS;
exports.isWindows = isWindows;
exports.getPlatForm = getPlatForm;
exports.getOS = getOS;
exports.getEnvironment = getEnvironment;
var ua = window.navigator.userAgent;

function isIOS() {
  return /iPad|iPhone|iPod/.test(ua);
}

function isAndroid() {
  return /android/i.test(ua);
}

function isWechat() {
  return /MicroMessenger/.test(ua);
}

function isApp() {
  return /lycheer/i.test(ua);
}

function isPC() {
  return !/(iPhone|iPod|Android|ios)/i.test(ua);
}

function isMacOS() {
  return /macintosh/i.test(ua);
}

function isWindows() {
  return /windows/i.test(ua);
}

function getPlatForm() {
  if (isWechat()) {
    return 'wechat';
  }

  if (isApp()) {
    return 'app';
  }

  return 'unknown';
}

function getOS() {
  if (isIOS()) {
    return 'ios';
  }

  if (isAndroid()) {
    return 'android';
  }

  if (isMacOS()) {
    return 'macos';
  }

  if (isWindows()) {
    return 'windows';
  }

  return 'unknown';
}

function getEnvironment() {
  return {
    os: getOS(),
    platform: getPlatForm()
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@weike/toolkit/lib/platform/index.js
// module id = 638
// module chunks = 4